function throttle(func, delay) {
    let isThrottling = false;
    return function(...args) {
        if (!isThrottling) {
            func.apply(this, args);
            isThrottling = true;
            setTimeout(()=>{
                isThrottling = false;
            }, delay);
        }
    };
}
const pclnPropertyTypeGroupingConfig = {
    1001: 'Apartment',
    1002: 'Hostel',
    1003: 'Hotel',
    1004: 'Motel',
    1005: 'Resort',
    1006: 'Residence',
    1007: 'Farm stay',
    1008: 'Holiday park',
    1009: 'Bungalow',
    1010: 'Villa',
    1011: 'Campsite',
    1012: 'Boat/cruise',
    1013: 'Inn',
    1014: 'Aparthotel',
    1015: 'Holiday home',
    1016: 'Lodge',
    1017: 'Homestay',
    1018: 'Tent',
    1019: 'Capsule hotel',
    1020: 'Love hotel',
    1021: 'Traditional stay',
    1022: 'Guesthouse',
    1023: 'Student accommodation'
};
const transformSOPQName = ({ starRating, location, pclnPropertyTypeId })=>`A ${starRating}-star ${pclnPropertyTypeGroupingConfig[pclnPropertyTypeId]} in the ${location?.zoneName} `;
export { throttle, transformSOPQName };
